(() => {
  const SELECTOR = '[data-thumbnail-gallery]';

  function initializeGallery(gallery) {
    if (!gallery || gallery.dataset.thumbnailInitialized === 'true') return;

    const navigation = gallery.querySelector('.thumbnail-scroll-container');
    const list = gallery.querySelector('.thumbnail-list');
    const previousButton = gallery.querySelector('#thumb-up');
    const nextButton = gallery.querySelector('#thumb-down');
    const thumbnails = () => Array.from(gallery.querySelectorAll('.thumbnail'));
    const mediaContainer = gallery.querySelector('#main-media-container');

    if (!navigation || !list) return;
    gallery.dataset.thumbnailInitialized = 'true';

    const applyResponsiveSettings = () => {
      const viewport = window.innerWidth;
      const breakpoint = viewport <= 768 ? 'mobile' : viewport <= 1024 ? 'tablet' : 'desktop';
      const breakpointKey = `${breakpoint[0].toUpperCase()}${breakpoint.slice(1)}`;
      const position = gallery.dataset[`thumbnailPosition${breakpointKey}`] || 'below';
      const layout = gallery.dataset[`thumbnailLayout${breakpointKey}`] || 'vertical';
      gallery.dataset.thumbnailPosition = position;
      gallery.dataset.thumbnailOrientation = layout;
      navigation.dataset.thumbnailOrientation = layout;
    };

    const setActiveThumbnail = (thumbnail) => {
      thumbnails().forEach((item) => {
        const isActive = item === thumbnail;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-current', String(isActive));
      });
    };

    const syncFromMainMedia = () => {
      const currentMedia = mediaContainer?.querySelector('[data-media-id]');
      if (!currentMedia) return;
      const activeThumbnail = thumbnails().find((thumbnail) => thumbnail.dataset.mediaId === currentMedia.dataset.mediaId);
      if (activeThumbnail) setActiveThumbnail(activeThumbnail);
    };

    const moveToThumbnail = (direction) => {
      const items = thumbnails();
      if (!items.length) return;
      const currentIndex = Math.max(0, items.findIndex((item) => item.classList.contains('active')));
      const target = items[currentIndex + direction];
      if (!target) return;
      target.click();
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };

    gallery.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('.thumbnail');
      if (!thumbnail || !gallery.contains(thumbnail)) return;
      setActiveThumbnail(thumbnail);
    });

    previousButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      moveToThumbnail(-1);
    }, true);

    nextButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      moveToThumbnail(1);
    }, true);

    const observer = new MutationObserver(syncFromMainMedia);
    if (mediaContainer) observer.observe(mediaContainer, { childList: true, subtree: true });

    applyResponsiveSettings();
    syncFromMainMedia();
    window.addEventListener('resize', applyResponsiveSettings, { passive: true });
  }

  const initializeAll = (scope = document) => {
    if (scope.matches?.(SELECTOR)) initializeGallery(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(initializeGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
